import type { Theme } from '@mui/material';
import { alpha } from '@mui/material';

export type FlowControlSegmentAccent = 'error' | 'info';

/** Live playout uses error; simulation uses info for active segment chrome. */
export function resolveFlowControlSegmentAccent(isLiveContextRunning: boolean): FlowControlSegmentAccent {
  return isLiveContextRunning ? 'error' : 'info';
}

/** Playing segment fill — stronger than item staging tints; segments use fill instead of a colored border. */
export function flowControlActiveSegmentBackground(theme: Theme, accent: FlowControlSegmentAccent) {
  return alpha(theme.palette[accent].main, theme.palette.mode === 'dark' ? 0.36 : 0.28);
}

/** Next / look-ahead segment fill (success) — no colored outline on segment rows. */
export function flowControlNextCueSegmentBackground(theme: Theme) {
  return alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.32 : 0.24);
}

/** Idle segment row fill in Control list (primary tint — distinct from simulation header chrome). */
export function flowControlIdleSegmentBackground(theme: Theme) {
  return alpha(theme.palette.primary.main, 0.2);
}
